// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-144a3602]{display:block;max-width:100%}.image.is-wide[data-v-144a3602]{width:100%}.image.is-tall[data-v-144a3602]{height:100%}.image.is-cover[data-v-144a3602]{-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
